import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { get } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge, statusTone } from "@/components/common";
import { GraduationCap } from "lucide-react";

export default function Teachers() {
  const nav = useNavigate();
  const [status, setStatus] = useState("");
  const { data, isLoading } = useQuery({ queryKey: ["admin-teachers", status], queryFn: () => get(`/admin/teachers${status ? `?status=${status}` : ""}`) });
  return (
    <div>
      <PageHeader title="Teacher Management" subtitle="Approve and manage faculty" />
      <div className="flex gap-2 mb-5">
        {[["", "All"], ["pending", "Pending"], ["approved", "Approved"], ["rejected", "Rejected"], ["suspended", "Suspended"]].map(([k, l]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`teacher-filter-${k || "all"}`} className={`px-4 py-2 rounded-lg text-sm font-semibold ${status === k ? "bg-indigo-800 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      {isLoading ? <PageLoader /> : !data?.length ? <EmptyState icon={GraduationCap} title="No teachers" /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{data.map((t) => (
          <div key={t.id} onClick={() => nav(`/admin/teachers/${t.id}`)} data-testid={`teacher-card-${t.id}`} className="bg-white rounded-2xl border border-slate-200 p-5 card-hover cursor-pointer">
            <div className="flex items-center gap-3"><div className="h-12 w-12 rounded-full bg-teal-700 text-white flex items-center justify-center font-bold">{t.name?.slice(0, 1)}</div><div><p className="font-semibold text-slate-800">{t.name}</p><p className="text-xs text-slate-500">{t.email}</p></div></div>
            <p className="text-sm text-slate-500 mt-3 line-clamp-2">{t.profile?.bio}</p>
            <div className="flex items-center justify-between mt-3"><div className="flex flex-wrap gap-1">{(t.profile?.subjects || []).slice(0, 2).map((s) => <Badge key={s} tone="slate">{s}</Badge>)}</div><Badge tone={statusTone(t.profile?.approval_status)}>{t.profile?.approval_status}</Badge></div>
          </div>))}</div>
      )}
    </div>
  );
}
